import { z } from 'zod';
import { isoDateTimeSchema } from './primitives.js';
/** A bilingual text value `{ ar, en }` (settings, catalog names). */
export const bilingualTextSchema = z.object({
    ar: z.string(),
    en: z.string(),
});
/** The same shape for input: both languages are required and trimmed. */
export const bilingualTextInputSchema = (max) => z.object({
    ar: z.string().trim().min(1).max(max),
    en: z.string().trim().min(1).max(max),
});
/** An employee as shown beside an action (who confirmed, delivered, edited). */
export const employeeRefSchema = z.object({
    id: z.string(),
    nameAr: z.string(),
    nameEn: z.string(),
});
/** A branch as cached from Unified Access. */
export const branchRefSchema = z.object({
    id: z.string(),
    code: z.string(),
    nameAr: z.string(),
    nameEn: z.string(),
});
/** A currency as embedded in a deposit, report row or total. */
export const currencyRefSchema = z.object({
    id: z.string(),
    code: z.string(),
    nameAr: z.string(),
    nameEn: z.string(),
});
/** Who did something and when. */
export const actionStampSchema = z.object({
    by: employeeRefSchema,
    at: isoDateTimeSchema,
});
/** Header carried by every committing POST (SH-13). */
export const IDEMPOTENCY_HEADER = 'idempotency-key';
//# sourceMappingURL=refs.js.map